<template>
    <div
        :class="['image-block', {
            block: layout.inline
        }]"
    >
        <img
            class="image-holder"
            :src="layout.imageblock"
            :alt="'Fullscreen picture ' + layout.imageblock.split('/').pop().split('.')[0]"
        />
    </div>
</template>

<script>
export default {
    props: {
        layout: {
            type: Object,
            default() {}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.image-block
    @media print
        margin-left: 10.41667%
        margin-right: 10.41667%
        margin-top: 1.2cm
        margin-bottom: 1.2cm
    img
        display: block
        width: 100%
        height: auto

</style>
